module.exports = __webpack_public_path__ + "static/media/mail-line.39824602.svg";